/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
 */

var Lajax = (function () {
    'use strict';

    var baseObjectString = 'l-ajax-js', // Used for data attrs and classes
        inlineLoaderClass = 'button--loader', // Used with the button block styles for inline loader
        inlineLoadingClass = 'button--loading',
        ajaxInProgress = false; // Indicates if a call is in progress

    // ----------------------
    // Private methods
    // ----------------------

    var _resetApp = function() {
        // Reset ajax state
        ajaxInProgress = false;

        // for other modules
        pubsubEvent.emit('pubsubEvent_ajaxComplete');

        // Re-bind trigger click (and recreate loaders if needed)
        init();
    };

    var _updateView = function($trigger, dataObj) {
        // Check there is content returned
        if (dataObj.content !== undefined) {
            var scrollToElementId = dataObj.scrollto,
                contentMappings = dataObj.content;

            // Iterate over the new content
            $.each(contentMappings, function (mapType, mapData) {
                // allow only specified types of mapping
                if (['replace', 'append', 'update'].indexOf(mapType) > -1) {
                    $.each(mapData, function (selector, htmlData) {
                        var $el = $(selector);

                        if ($el.length) {
                            if (mapType === 'replace') {
                                // Replace whole element
                                $el.replaceWith(htmlData);
                            } else if (mapType === 'append') {
                                // Append the content
                                $el.append(htmlData);
                            } else if (mapType === 'update') {
                                // Update the content

                                // content might be wrapped with the spinner wrapper
                                var $spinnerEl = $el.find('.' + baseObjectString + '-inner');

                                if ($spinnerEl.length) {
                                    $spinnerEl.siblings().remove();
                                    $spinnerEl.parent().append(htmlData);
                                } else {
                                    // Append the content
                                    $el.html(htmlData);
                                }
                            }
                        }
                    });
                }
            });

            // Scroll to the element
            var scrolltoTarget = $(scrollToElementId);
            if (scrolltoTarget !== undefined && scrolltoTarget.length) {
                var scrolltoTargetLink = scrolltoTarget.find('a');

                // focus the first link inside the scrollToTarget
                if (scrolltoTargetLink.length) {
                    scrolltoTargetLink.focus();
                }

                if (scrolltoTarget.offset()) {
                    scrolltoTarget = scrolltoTarget.length ? scrolltoTarget : $('[name=' + this.hash.slice(1) + ']');
                    $('html, body').animate({
                        scrollTop: scrolltoTarget.offset().top
                    }, 500);
                }
            }

            // Update numresults on process pages
            _updateProcessNumresults();
        } else {
            // Backend error
            $trigger.after('<p>There seems to be a problem with this action. Please try again later.</p>');
        }

        // Remove the loader
        _setLoadingState($trigger, false);

        // Reset
        _resetApp();

        // Log the data
        // console.log(dataObj)
    };

    var _setLoadingState = function($trigger, state) {
        // Get all the items requiring a loader
        var loaderItems = $trigger.data(baseObjectString + '-loader').split(',').map(JSON.parse);

        $.each(loaderItems, function(index, el) {
            // Add the loader
            if (state === true) {
                window.requestAnimationFrame(function() {
                    // Conditional to see if its a button or not
                    if ($(el).is('button, input, a')) {
                        $(el).addClass(inlineLoadingClass);
                    } else {
                        $(el).find('.' + baseObjectString + '-inner').off('transitionend.ajaxout');
                        $(el).find('.' + baseObjectString + '-inner').addClass(baseObjectString + '-inner--in');
                    }

                    // Get the ajaxed data
                    _getAjaxData($trigger);
                });
            } else if (state === false) {
                // remove the loader (if still present)
                window.requestAnimationFrame(function () {
                    if ($(el).length) {
                        if ($(el).is('button, input, a')) {
                            $(el).removeClass(inlineLoadingClass);

                            // Reset
                            _resetApp();
                        } else {
                            $(el).find('.' + baseObjectString + '-inner').addClass(baseObjectString + '-inner--out');

                            $(el).find('.' + baseObjectString + '-inner').off('transitionend.ajaxout').on('transitionend.ajaxout', function (event) {
                                $(el).find('.' + baseObjectString + '-inner').removeClass(baseObjectString + '-inner--in');
                                $(el).find('.' + baseObjectString + '-inner').removeClass(baseObjectString + '-inner--out');

                                // Reset
                                _resetApp();
                            });
                        }
                    }
                });
            }
        });
    };

    var _setPreLoadingState = function($trigger) {
        // Get all the items requiring a loader
        var loaderItems = $trigger.data(baseObjectString + '-loader').split(',').map(JSON.parse);

        // Set to loadable content
        $.each(loaderItems, function(index, el) {
            if ($(el).is('button, input, a')) {
                if (!$(el).hasClass(inlineLoaderClass)) {
                    $(el).addClass(inlineLoaderClass);
                }
            } else {
                if ($(el).find('.' + baseObjectString).length === 0) {
                    $(el).wrapInner('<div class="' + baseObjectString + '"></div>');
                    $(el).find('.' + baseObjectString).prepend('<div class="' + baseObjectString + '-inner"></div>');
                }
            }
        });
    };

    var _getAjaxData = function($trigger) {
        var actionURL,
            submitData;

        if ($trigger.is('[type="submit"]')) {
            var $form = $trigger.parents('form');
            // Form action and data
            actionURL = $form.attr('action');
            submitData = $form.serialize();
        } else {
            // For a regular link or button ust use the href
            actionURL = $trigger.attr('href');
            submitData = '';
        }

        // Timed out so no jumpy changes
        setTimeout(function() {
            $.ajax({
                url: actionURL,
                type: 'GET',
                dataType: 'json',
                data: submitData,
                encode: true,
                cache: false
            })
            .done(function(resultObj) {
                var stateURL = actionURL + (submitData ? ('?' + submitData) : ''),
                    stateObj = {
                        stateURL: stateURL
                    },
                    ga = window[window.GoogleAnalyticsObject || 'ga'];

                window.history.pushState(stateObj, '', stateURL);

                if (typeof ga === 'function') {
                     ga('send', 'pageview', stateURL);
                }

                // Update the content

                _updateView($trigger, resultObj);
            })
            .fail(function(e) {
                $trigger.after('<p>There seems to be a problem triggering this action. Please try again later.</p>');
            });
        }, 500);
    };

    // Handle using the back button
    var _popState = function() {
        window.addEventListener('popstate', function(e) {
            // Make sure Safari (ios8) popstate isnt triggered when the page is loaded
            var popStatus = Cookies.get('prevPopped');

            // Has the cookie been set
            if (popStatus !== null) {
                // Is it not the same as the current page
                if (popStatus !== window.location.href) {
                    Cookies.set('prevPopped', window.location.href);
                    location.reload();
                }
            }
        });
    };

    var _bindTriggerClick = function() {
        var $triggers = $('[data-' + baseObjectString + '-trigger]');

        // if a trigger exists
        if ($triggers.length) {
            $triggers.each(function(index, el) {
                var thisTrigger = $(this);

                thisTrigger.off('click.ajax').on('click.ajax', function(e) {
                    e.preventDefault();
                    // Prevent multiple requests
                    if (ajaxInProgress === false) {
                        // Set in progress
                        ajaxInProgress = true;

                        _setLoadingState(thisTrigger, true);
                    }
                });
            });
        }
    };

    var _updateProcessNumresults = function() {
        if ($('.processlist').length > 0) {
            $('.js-listing-numshowing').html(($('.processlist-item').length));
        }
    };

    // ----------------------
    // Public methods
    // ----------------------

    var init = function() {
        var $triggers = $('[data-' + baseObjectString + '-trigger]');

        // if a trigger exists
        if ($triggers.length) {
            $triggers.each(function(index, el) {
                var thisTrigger = $(this);

                // Add class to prepare for loaders
                _setPreLoadingState(thisTrigger);
            });

            _bindTriggerClick();
            // Setup popstate for history API
            _popState();
        }
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Lajax.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

var Cannouncement = (function () {
    'use strict';

    // Component vars
    var componentClass = 'announcement',
        cookieHideValue = 'hide';

    var _bindEvents = function($announcement, $closeBtn) {
        $closeBtn.on('click', function(event) {
            event.preventDefault();

            $announcement.css({
                opacity: 0
            });

            $announcement.off('transitionend.announce').on('transitionend.announce',
                function(event) {
                    // Do something when the transition ends
                    $announcement.attr('aria-hidden', true);
                    $announcement.css({
                        height: 0
                    });
                    $announcement.off('transitionend.announceRemove').on('transitionend.announceRemove',
                        function(event) {
                            $announcement.hide();

                            // Store the fact this has been closed
                            Cookies.set($closeBtn.attr('id'), cookieHideValue,
                                {expires: $announcement.data('dismiss-expiry-time')});
                    });
                });
        });

        // So Behaves like a button
        $closeBtn.on('keypress', function(e) {
            if (e.which === 32) {
                $(this).trigger('click');
                e.preventDefault();
            }
        });
    };

    var _setAccessAttrs = function($announcement, $closeBtn) {
        // Needs this role as is not an anchor with js
        $closeBtn.attr('role', 'button');

        var $announcementHeight;

        // Use on load as otherwise safari doesn't measure correctly
        $(window).on('load', function() {
            $announcementHeight = $announcement.outerHeight(true);

            // anim
            $announcement.css({
                opacity: 1,
                height: $announcementHeight,
                transition: 'opacity .2s ease, height .2s ease'
            });
        });
        // aria
        $announcement.attr({
            'id': componentClass,
            'aria-hidden': false
        });
    };

    // Public method
    var init = function() {
        var $announcement = $('.' + componentClass);

        if ($announcement.length) {
            var $closeBtn = $announcement.find('.' + componentClass + '__close');

            if ($closeBtn.length) {
                _setAccessAttrs($announcement, $closeBtn);
                _bindEvents($announcement, $closeBtn);
            }
        }
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Cannouncement.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary Enhancement to the jquery-accessible-tabs.js library to facilitate select style presentation on mobile
 * Adds additional state classes to allow for styling like a select
 *
*/

// Create namespace for module
var Btabs = (function () {
    'use strict';

    // Validation method
    // Check all elements that shouls be are th
    // var _spanValidation = function(tableInnards) {

    // }

    // Validation method
    // if non default table and rowspan/colspan used check not been applied to first header element
    var _BindUIEvents = function($tabpanel) {
        var $list = $tabpanel.find('.b-js-tabs__list'),
            $item = $tabpanel.find('.b-js-tabs__item'),
            $link = $tabpanel.find('.b-js-tabs__link');

         $item.on('click', function(event) {
            $('body').keydown(function () {
                $list.addClass('b-js-tabs__list--active');
            });

            $list.toggleClass('b-js-tabs__list--active');
            console.log('click fired');
        });

        $('html').on('click', function(event) {
            if (!$(event.target).hasClass('b-js-tabs__link')) {
                $list.removeClass('b-js-tabs__list--active');
            }
        });

        $link.on('focus', function(event) {
            $(this).parent().siblings().removeClass('b-js-tabs__item--active');
            $(this).parent().addClass('b-js-tabs__item--active');
            /* Act on the event */
        });
    };

    // add escape key to remove b-js-tabs__list--active
    // add toggle b-js-tabs__list--active when focussed and click enter

    // Public method
    var init = function() {
        $('.b-js-tabs').each(function(index, el) {
            _BindUIEvents($(this));
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Btabs.init();
});

/**
 * @requires jquery.js
 * @requires b-back-to-top.scss
 *
 * @summary Animated scroll to top of the page
 *
 */

var BbackToTop = (function () {
    'use strict';

    var settings = {
        fromTop: 400,
        delay: 200
    };

    var _bindUIActions = function () {
        var $backToTop = $('.b-back-to-top');

        // Show / hide anchor after scrolling stopped
        $(window).scroll(function () {
            clearTimeout($.data(this, 'scrollTimer'));

            $.data(this, 'scrollTimer', setTimeout(function () {
                if ($(window).scrollTop() > settings.fromTop) {
                    $backToTop.addClass('b-back-to-top--show');
                } else {
                    $backToTop.removeClass('b-back-to-top--show');
                }
            }, settings.delay));
        });

        // Make 'back to top' link go... well, back to top.
        // This should have been handled by the `href="#top"` in `.b-back-to-top__link`
        // but has been compromised by `rewrite_hash_links: false` in `config.yml`
        $('.b-back-to-top__link').on('click', function() {
            $('html, body').animate({ scrollTop: 0 }, 420);
            return false;
        });
    };

    var init = function() {
        _bindUIActions();
    };

    return {
        init: init
    };
})();

$(document).ready(function() {
    BbackToTop.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

// Create namespace for module
var Bhideshow = (function () {
    'use strict';

    // Stores the content set by data attrs
    var baseClassString = 'b-hide-show-js',
        togglerActiveClass = baseClassString + '__trigger--isactive',
        togglerContent,
        togglerAltContent;

    var _setInactiveAttrs = function($toggler, $block) {
        $block.attr('aria-hidden', true).hide();
        $toggler
            .html(togglerContent)
            .removeClass(togglerActiveClass)
            .attr('aria-expanded', false);
    };

    var _setActiveAttrs = function($toggler, $block) {
        $block.attr('aria-hidden', false).show();
        $toggler
            .html(togglerAltContent)
            .addClass(togglerActiveClass)
            .attr('aria-expanded', true);
    };

    var _bindEvents = function($toggler, $block) {
        $toggler.off('click').on('click', function() {
            if ($block.attr('aria-hidden') === 'true') {
                _setActiveAttrs($toggler, $block);
            } else {
                _setInactiveAttrs($toggler, $block);
            }
        });
    };

    var _setInitialAttrs = function($toggler, $block, index) {
        var blockId = 'b-hide-show-js' + index;
        togglerContent = $toggler.data(baseClassString + '-content');
        togglerAltContent = $toggler.data(baseClassString + '-alt-content');

        $block.attr('id', blockId);

        $toggler.attr({
            'aria-owns': blockId,
            'aria-haspopup': true,
            'aria-expanded': false
        });

        // Check to see if it has the open data attr
        if ($block.data('b-hide-show-js-open') === true) {
            _setActiveAttrs($toggler, $block);
        } else {
            _setInactiveAttrs($toggler, $block);
        }
    };

    var _findElements = function ($wrappers) {
        $wrappers.each(function(index, el) {
            var $wrapper = $(this),
                $toggler = $wrapper.find('.' + baseClassString + '__trigger'),
                $block = $wrapper.find('.' + baseClassString + '__block');

                $block.show();

            // Important:
            // This is used as the CSS hook to determine if the breakpoint requires use of the hide/show
            if ($toggler.css('display') === 'block') {
                _setInitialAttrs($toggler, $block, index);
                _bindEvents($toggler, $block);
            }
        });
    };

    // Exposed function
    var init = function() {
        var $wrappers = $('.' + baseClassString);

        if ($wrappers.length > 0) {
            // Initialise
            _findElements($wrappers);

            // used for ios where a scroll can trigger resize
            var cachedWidth = $(window).width();

            // Re initialise on resize
            var resizeTimer;
            $(window).on('resize', function(e) {
                var newWidth = $(window).width();

                // Check to see if width has actually changed (ios specific)
                if (newWidth !== cachedWidth) {
                    clearTimeout(resizeTimer);

                    resizeTimer = setTimeout(function() {
                            _findElements($wrappers);
                    }, 250);
                }
            });
        }
    };

    // ----------------------
    // Observe events
    // ----------------------

    pubsubEvent.on('pubsubEvent_ajaxComplete', init);

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Bhideshow.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
 *
 */

var BlinkExternal = (function () {
    'use strict';

    var init = function () {
        var hostname = window.location.hostname,
            mainSelector = '[data-enhance-external-links]',
            externalLinksSelector = 'a[href^="http"]:not(a[href*="' + hostname + '"])';

        $(mainSelector + ' ' + externalLinksSelector).each(function () {
            var $externalLink = $(this),
                $externalLinkEnhanceWrapper = $externalLink.closest(mainSelector),
                externalLinkClass = 'b-link-external';

            if ($externalLinkEnhanceWrapper.data('external-link-class')) {
                externalLinkClass = $externalLinkEnhanceWrapper.data('external-link-class');
            }

            if (!$externalLink.hasClass(externalLinkClass)) {
                if (!$externalLink.children('img').length) {
                    $externalLink.addClass(externalLinkClass);
                }
            }
        });
    };

    // ----------------------
    // Observe events
    // ----------------------

    pubsubEvent.on('pubsubEvent_ajaxComplete', init);

    return {
        init: init
    };
})();

$(document).ready(function() {
    BlinkExternal.init();
});


/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

// Create namespace for module
var Bmodaal = (function () {
    'use strict';

    // Public method
    var init = function() {
        var inline = $('[data-modaltrigger]');
        $('.modaal-ajax-js').modaal({
            type: 'ajax'
        });
        $('.modaal-image-js').modaal({
            type: 'image'
        });
        $('.modaal-video-js').modaal({
            type: 'video'
        });

        inline.modaal({
            type: 'inline'
        });

        $('[data-closemodal]').on('click', function() {
            inline.modaal('close');
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Bmodaal.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary Desktop mega-menu navigation using the WAI-ARIA disclosure pattern.
 * @see https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/
 *
 * WARNING: This file is duplicated across themes/default, themes/ewrb, and themes/iaa.
 * Changes made here must be applied to all three copies to avoid drift.
*/

var BnavDesktop = (function () {
    'use strict';

    var navExpanded = false,
        baseObjectString = 'navdesktop-js',
        activeTriggerClass = baseObjectString + '__reveal--in',
        transitionInProgress = false,
        transitionSafetyTimer = null,
        TRANSITION_SAFETY_MS = 300;

    // ----------------------
    // Private methods
    // ----------------------

    /**
     * Reset the safety timer that unlocks transitions if transitionend never fires.
     */
    var _resetSafetyTimer = function() {
        clearTimeout(transitionSafetyTimer);
        transitionSafetyTimer = setTimeout(function() {
            transitionInProgress = false;
        }, TRANSITION_SAFETY_MS);
    };

    /**
     * Animate the mega panel into view.
     * @param {jQuery} $mega - The mega panel element
     * @param {jQuery} $trigger - The disclosure button that controls this panel
     */
    var _fadeIn = function($mega, $trigger) {
        navExpanded = true;
        _resetSafetyTimer();

        window.requestAnimationFrame(function() {
            // Animate in
            $trigger.addClass(activeTriggerClass);
            $mega.addClass(baseObjectString + '__mega--in');

            $mega.off('transitionend.megaIn').on('transitionend.megaIn', function() {
                // Set state
                clearTimeout(transitionSafetyTimer);
                transitionInProgress = false;
                $mega.off('transitionend.megaIn');
            });
        });
    };

    /**
     * Animate the mega panel out of view.
     * @param {jQuery} $mega - The mega panel element
     * @param {jQuery} $trigger - The disclosure button that controls this panel
     */
    var _fadeOut = function($mega, $trigger) {
        navExpanded = false;
        _resetSafetyTimer();

        window.requestAnimationFrame(function() {
            // Animate out
            $mega.addClass(baseObjectString + '__mega--out');
            $trigger.removeClass(activeTriggerClass);

            $mega.off('transitionend.megaOut').on('transitionend.megaOut', function() {
                // Set mega state
                $mega.removeClass(baseObjectString + '__mega--out')
                    .removeClass(baseObjectString + '__mega--in');

                // Set global state
                clearTimeout(transitionSafetyTimer);
                transitionInProgress = false;
                $mega.off('transitionend.megaOut');
            });
        });
    };

    /**
     * Swap from one open mega panel to another without a close-then-open delay.
     * @param {jQuery} $megasOut - The mega panel(s) to hide
     * @param {jQuery} $megaIn - The mega panel to show
     * @param {jQuery} $triggersOut - The trigger(s) to deactivate
     * @param {jQuery} $triggerIn - The trigger to activate
     */
    var _replace = function($megasOut, $megaIn, $triggersOut, $triggerIn) {
        $megasOut.removeClass(baseObjectString + '__mega--out')
                .removeClass(baseObjectString + '__mega--in');
        _resetSafetyTimer();

        window.requestAnimationFrame(function() {
            $megaIn.addClass(baseObjectString + '__mega--in');

            $triggersOut.removeClass(activeTriggerClass);
            $triggerIn.addClass(activeTriggerClass);

            $triggerIn.off('transitionend.triggerIn').on('transitionend.triggerIn', function() {
                // Set global state
                clearTimeout(transitionSafetyTimer);
                transitionInProgress = false;
                $triggerIn.off('transitionend.triggerIn');
            });
        });
    };

    /**
     * Determine the action based on which trigger was activated and the current state.
     * Handles open, close, and swap between panels.
     * @param {jQuery} $thisTrigger - The trigger that was activated
     * @param {jQuery} $thisMega - The mega panel associated with the trigger
     * @param {jQuery} $triggers - All disclosure trigger buttons
     * @param {jQuery} $megas - All mega panel elements
     */
    var _toggleState = function($thisTrigger, $thisMega, $triggers, $megas) {
        // Determine if any mega is already open
        var megaActive = false;
        $megas.each(function() {
            if ($(this).is('.' + baseObjectString + '__mega--in')) {
                megaActive = true;
            }
        });

        // Close by clicking the open item's trigger
        if ($thisTrigger.is('.' + activeTriggerClass)) {
            _fadeOut($thisMega, $thisTrigger);
            $thisTrigger.attr('aria-expanded', 'false');

        // Mega is open, but clicked on another trigger
        } else if (megaActive) {
            var $megasOut = $('.' + baseObjectString + '__mega').not($thisMega),
                $triggersOut = $('button.' + baseObjectString + '__reveal').not($thisTrigger);

            _replace($megasOut, $thisMega, $triggersOut, $thisTrigger);
            $triggersOut.attr('aria-expanded', 'false');
            $thisTrigger.attr('aria-expanded', 'true');

        // Nothing is currently open
        } else {
            _fadeIn($thisMega, $thisTrigger);
            $thisTrigger.attr('aria-expanded', 'true');
        }
    };

    /**
     * Close the currently open panel and update its trigger state.
     */
    var _closeActivePanel = function() {
        var $activeTrigger = $('.' + activeTriggerClass);
        if ($activeTrigger.length) {
            var $activeMega = $activeTrigger.next('.' + baseObjectString + '__mega');
            transitionInProgress = true;
            _fadeOut($activeMega, $activeTrigger);
            $activeTrigger.attr('aria-expanded', 'false');
        }
    };

    // ----------------------
    //  Public methods
    // -----------------------

    var init = function() {
        var $navContainer = $('.' + baseObjectString),
            $triggers = $('button.' + baseObjectString + '__reveal'),
            $megas = $('.' + baseObjectString + '__mega');

        // Bind click on disclosure buttons (items with mega menus)
        $triggers.each(function() {
            var $trigger = $(this);

            // Close any other open panel when this trigger receives focus
            $trigger.on('focus', function() {
                var $focusedTrigger = $(this);
                if (
                    navExpanded &&
                    !transitionInProgress &&
                    !$focusedTrigger.is('.' + activeTriggerClass)
                ) {
                    _closeActivePanel();
                }
            });

            $trigger.on('click', function(e) {
                var $clickedTrigger = $(this),
                    $thisMega = $clickedTrigger.next('.' + baseObjectString + '__mega');

                e.stopPropagation();

                if (transitionInProgress === false) {
                    transitionInProgress = true;
                    _toggleState($clickedTrigger, $thisMega, $triggers, $megas);
                }
            });
        });

        // Escape key closes the open panel and returns focus to its trigger
        $(document).on('keydown.megaEscape', function(e) {
            if (e.key === 'Escape' && navExpanded && !transitionInProgress) {
                var $activeTrigger = $('.' + activeTriggerClass);
                if ($activeTrigger.length) {
                    _closeActivePanel();
                    $activeTrigger.focus();
                }
            }
        });

        // Close panel when focus leaves the nav container (WCAG 1.4.13)
        $navContainer.on('focusout.megaFocus', function() {
            setTimeout(function() {
                if (
                    navExpanded &&
                    !transitionInProgress &&
                    !$navContainer[0].contains(document.activeElement)
                ) {
                    _closeActivePanel();
                }
            }, 0);
        });

        // Click away from nav closes the panel
        $('body').off('click.megaBody').on('click.megaBody', function(event) {
            if (transitionInProgress === false && navExpanded === true) {
                if (
                    !$(event.target).parents('.' + baseObjectString + '__mega').length &&
                    !$(event.target).is('.' + baseObjectString + '__mega') &&
                    $('.' + activeTriggerClass).length
                ) {
                    _closeActivePanel();
                }
            }
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    BnavDesktop.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary Mobile navigation using the WAI-ARIA disclosure pattern.
 * @see https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/
 */

var BnavMobile = (function () {
    'use strict';

    var _setAccessAttrs = function($navWrapper) {
        $navWrapper.attr({
            'aria-hidden': 'true'
        });
    };

    /**
     * Close the mobile menu and reset trigger state.
     */
    var _closenav = function() {
        var $navWrapper = $('.navmobile-listwrapper'),
            $navTrigger = $('.navmobile-trigger');

        $navTrigger.removeClass('navmobile-trigger--isactive');
        $navWrapper.attr('aria-hidden', 'true');
        $navTrigger.attr('aria-expanded', 'false');
        $navTrigger.attr('aria-label', 'Open menu');
        $navWrapper.hide();
        $('body').removeClass('overlay--active');
    };

    /**
     * Toggle the mobile menu open/closed and update trigger state.
     */
    var _toggleAttrs = function($navWrapper, $navTrigger) {
        $('html, body').scrollTop(0);

        $navTrigger.toggleClass('navmobile-trigger--isactive');

        if ($navWrapper.attr('aria-hidden') === 'true') {
            $navWrapper.attr('aria-hidden', 'false');
            $navTrigger.attr('aria-expanded', 'true');
            $navTrigger.attr('aria-label', 'Close menu');
            $navWrapper.show();
            $('body').addClass('overlay--active');
        } else {
            _closenav();
        }
    };

    /**
     * Initialise disclosure toggle for section headers.
     * Each button toggles aria-expanded and the hidden attribute on its panel.
     */
    var _initDisclosure = function() {
        var $buttons = $('.navmobile-section__header');

        $buttons.on('click', function() {
            var $button = $(this);
            var isExpanded = $button.attr('aria-expanded') === 'true';
            var $panel = $('#' + $button.attr('aria-controls'));

            $button.attr('aria-expanded', String(!isExpanded));

            if (isExpanded) {
                $panel.attr('hidden', '');
            } else {
                $panel.removeAttr('hidden');
            }
        });
    };

    // Public method
    var init = function() {
        var $navWrapper = $('.navmobile-listwrapper'),
            $navTrigger = $('.navmobile-trigger');

        _setAccessAttrs($navWrapper);
        _initDisclosure();

        $navTrigger.on('click', function(e) {
            e.preventDefault();
            _toggleAttrs($navWrapper, $navTrigger);

            pubsubEvent.emit('pubsubEvent_mobileNavClicked');
        });

        // Escape key closes the menu and returns focus to the trigger
        $(document).on('keydown.navmobileEscape', function(e) {
            if (e.key === 'Escape' && $navWrapper.attr('aria-hidden') === 'false') {
                _closenav();
                $navTrigger.focus();
            }
        });

        // Close menu and move focus to main content when tabbing past the last item
        $navWrapper.on('keydown', function(e) {
            if (e.key !== 'Tab' || e.shiftKey) return;

            var focusable = $navWrapper.find('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
            var lastFocusable = focusable.last()[0];

            if (document.activeElement === lastFocusable) {
                e.preventDefault();
                _closenav();

                var main = document.getElementById('main-content');
                if (main) {
                    main.setAttribute('tabindex', '-1');
                    main.focus();
                    $(main).one('blur', function() {
                        main.removeAttribute('tabindex');
                    });
                }
            }
        });
    };

    // ----------------------
    // Observe events
    // ----------------------

    pubsubEvent.on('pubsubEvent_siteSearchClicked', _closenav);

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    BnavMobile.init();
});

$(document).ready(function() {
    'use strict';

    var didScroll = false,
        lastScrollTop = 0,
        delta = 5;

    function init() {
        attachEvents();

        setInterval(function() {
            if (didScroll) {
                handleScroll();
                didScroll = false;
            }
        }, 500);
    }

    function attachEvents() {
        $(window).on('scroll', function() {
            didScroll = true;
        });
    }

    /**
     * On scrolling down we want to hide the secondary nav.
     * On scroll up we want to show it again
     */
    function handleScroll() {
        var scroll = $(window).scrollTop(),
            target = $('[data-navslide-scroll]'),
            newDelta = Math.abs(lastScrollTop - scroll);

        if (newDelta <= delta) {
            return;
        }

        // Scroll Down
        if (scroll > lastScrollTop) {
            target.removeClass('navslide-button--above');
        } else {
            target.addClass('navslide-button--above');
        }

        lastScrollTop = scroll;
    }

    init();
});


// Create namespace for module
var Bselect = (function () {
		'use strict';

		var getChoicesConfig = function() {
				return {
						silent: false,
						items: [],
						choices: [],
						renderChoiceLimit: -1,
						maxItemCount: -1,
						addItems: true,
						addItemFilterFn: null,
						removeItems: true,
						removeItemButton: true,
						editItems: false,
						duplicateItemsAllowed: true,
						delimiter: ',',
						paste: true,
						searchEnabled: true,
						searchChoices: true,
						searchFloor: 1,
						searchResultLimit: 4,
						searchFields: ['label', 'value'],
						position: 'auto',
						resetScrollPosition: true,
						shouldSort: false,
						shouldSortItems: false,
						placeholder: true,
						placeholderValue: null,
						searchPlaceholderValue: null,
						prependValue: null,
						appendValue: null,
						renderSelectedChoices: 'auto',
						loadingText: 'Loading...',
						noResultsText: 'No results found',
						noChoicesText: 'No choices to choose from',
						itemSelectText: 'Press to select'
				};
		};

		var addAutoClose = function(choices, element) {
				element.addEventListener('choice', function() {
						choices.hideDropdown();
				}, false);
		};

		var showPlaceholder = function(self) {
			const input = $(self).siblings('.choices__input.choices__input--cloned');

        if (input) {
            input.removeClass('choices__input--cloned--placeholder--hidden');
        }
		};

		var hidePlaceholder = function(self) {
			const input = $(self).siblings('.choices__input.choices__input--cloned');

        if (input) {
            input.addClass('choices__input--cloned--placeholder--hidden');
        }
		};

		var attachAddRemoveEvents = function(choices, element) {
        element.addEventListener('removeItem', function() {
            const isEmpty = typeof choices.getValue(true) === 'undefined' || choices.getValue(true).length < 1;

            if (isEmpty) {
                showPlaceholder(element);
            }
        }, false);

        element.addEventListener('addItem', function() {
            hidePlaceholder(element);
        }, false);
		};

		var fixInvalidAriaSelected = function(container) {
				var items = container.querySelectorAll('.choices__item[aria-selected]:not([role])');
				for (var i = 0; i < items.length; i++) {
						items[i].removeAttribute('aria-selected');
				}
		};

		var attachChoices = function(select) {
				var config = getChoicesConfig(select),
						choices,
						container;

				choices = new Choices(select, config);

				container = select.closest('.choices') || select.parentElement;
				fixInvalidAriaSelected(container);

				var observer = new MutationObserver(function() {
						fixInvalidAriaSelected(container);
				});
				observer.observe(container, {
						childList: true,
						subtree: true,
						attributes: true,
						attributeFilter: ['aria-selected']
				});

				addAutoClose(choices, select);
        attachAddRemoveEvents(choices, select);
		};

		var applyLabels = function() {
				var labelledSelects = $('select[aria-labelledby]');

				labelledSelects.each(function(index, el) {
						var select = $(this),
								label = select.attr('aria-labelledby');

						select.siblings('input').attr('aria-labelledby', label).attr('role', 'combobox');
						select.closest('.choices').find('[role="listbox"]').attr('aria-labelledby', label);
				});
		};

		// Exposed function
		var init = function() {
				// init all selects
				var selects = $('select'),
						i;

				for (i = 0; i < selects.length; i++) {
						attachChoices(selects[i]);
				}

				applyLabels();
		};

		// Expose objects here
		return {
				init: init
		};
})();

$(document).ready(function() {
		Bselect.init();
});

/**
 * @summary Accessible share menu following the ARIA Menu Button pattern.
 *          Supports both Up/Down and Left/Right arrow navigation to match
 *          the horizontal visual layout of the menu items.
 * @see https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/
 */

var ShareMenu = (function () {
    'use strict';

    var triggerSelector = '.js-share-menu-trigger';

    /**
     * Opens the menu and focuses either the first or last item.
     *
     * @param {boolean} focusLast - When true, focuses the last item (e.g. Up/Left Arrow on trigger).
     */
    var _open = function ($trigger, $menu, focusLast) {
        $trigger.attr('aria-expanded', 'true');
        $menu.prop('hidden', false);

        var $items = $menu.find('[role="menuitem"]');
        var $focusItem = focusLast ? $items.last() : $items.first();
        if ($focusItem.length) {
            $focusItem.focus();
        }
    };

    /**
     * Closes the menu and optionally returns focus to the trigger.
     */
    var _close = function ($trigger, $menu, returnFocus) {
        $trigger.attr('aria-expanded', 'false');
        $menu.prop('hidden', true);

        if (returnFocus) {
            $trigger.focus();
        }
    };

    var _isOpen = function ($trigger) {
        return $trigger.attr('aria-expanded') === 'true';
    };

    /**
     * Handles keyboard navigation within the menu.
     * Down/Right moves to the next item; Up/Left moves to the previous item.
     * Both axes wrap around. Escape closes and returns focus to the trigger.
     * Tab closes without returning focus, allowing natural browser tab flow.
     */
    var _handleMenuKeydown = function (event, $trigger, $menu) {
        var $items = $menu.find('[role="menuitem"]');
        var $focused = $(document.activeElement);
        var currentIndex = $items.index($focused);

        switch (event.keyCode) {
            case 27: // Escape
                event.preventDefault();
                _close($trigger, $menu, true);
                break;

            case 40: // Arrow Down
            case 39: // Arrow Right
                event.preventDefault();
                if (currentIndex < $items.length - 1) {
                    $items.eq(currentIndex + 1).focus();
                } else {
                    $items.first().focus();
                }
                break;

            case 38: // Arrow Up
            case 37: // Arrow Left
                event.preventDefault();
                if (currentIndex > 0) {
                    $items.eq(currentIndex - 1).focus();
                } else {
                    $items.last().focus();
                }
                break;

            case 9: // Tab
                _close($trigger, $menu, false);
                break;
        }
    };

    /**
     * Binds click and keyboard events for a single menu instance.
     */
    var _bindEvents = function ($trigger, $menu) {
        $trigger.off('click.shareMenu').on('click.shareMenu', function () {
            if (_isOpen($trigger)) {
                _close($trigger, $menu, true);
            } else {
                _open($trigger, $menu, false);
            }
        });

        $trigger.off('keydown.shareMenu').on('keydown.shareMenu', function (event) {
            if (_isOpen($trigger)) {
                return;
            }
            if (event.keyCode === 40 || event.keyCode === 39) { // Down/Right - focus first item
                event.preventDefault();
                _open($trigger, $menu, false);
            } else if (event.keyCode === 38 || event.keyCode === 37) { // Up/Left - focus last item
                event.preventDefault();
                _open($trigger, $menu, true);
            }
        });

        $menu.off('keydown.shareMenu').on('keydown.shareMenu', function (event) {
            _handleMenuKeydown(event, $trigger, $menu);
        });
    };

    var init = function () {
        var $triggers = $(triggerSelector);

        $triggers.each(function () {
            var $trigger = $(this);
            var menuId = $trigger.attr('aria-controls');
            var $menu = $('#' + menuId);

            if ($menu.length) {
                _bindEvents($trigger, $menu);
            }
        });

        // Bound once for all instances to avoid rebinding per trigger
        $(document).off('click.shareMenu touchend.shareMenu').on('click.shareMenu touchend.shareMenu', function (event) {
            var $target = $(event.target);

            $triggers.each(function () {
                var $trigger = $(this);
                var menuId = $trigger.attr('aria-controls');
                var $menu = $('#' + menuId);

                if ($menu.length && _isOpen($trigger) && !$target.closest('.articletools-share-container').length) {
                    _close($trigger, $menu, false);
                }
            });
        });
    };

    return {
        init: init
    };
})();

$(document).ready(function () {
    ShareMenu.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

// Create namespace for module
var BsiteSearch = (function () {
    'use strict';

    var _setAccessAttrs = function($ddWrapper, $searchTrigger) {
        $searchTrigger.attr({
            'aria-owns': 'b-site-search',
            'role': 'button',
            'aria-haspopup': true
        });

        $ddWrapper.attr({
            'id': 'b-site-search'
        });
    };

    var _toggleAttrs = function($ddWrapper, $searchTrigger) {
        $('html, body').scrollTop(0);

        $searchTrigger.toggleClass('sitesearch-reveal--isactive');

        if ($ddWrapper.attr('aria-hidden') === 'true') {
            $ddWrapper.attr('aria-hidden', false);
            $searchTrigger.html('Close<span class="sr-only"> the search dropdown</span>');
            $ddWrapper.show();
            $('.sitesearch-input').val('').focus();
            $('body').addClass('overlay--active');
            // $('.sitesearch-input').focus();
        } else {
            $ddWrapper.attr('aria-hidden', true);
            $searchTrigger.html('<span class="sr-only">Reveal the mobile </span>Search');
            $ddWrapper.hide();
            $('body').removeClass('overlay--active');
        }
    };

    var _closesearch = function() {
        var $ddWrapper = $('.sitesearch-wrapper'),
            $searchTrigger = $('.sitesearch-reveal');

        $searchTrigger.removeClass('sitesearch-reveal--isactive');
        $ddWrapper.attr('aria-hidden', true);
        $searchTrigger.html('<span class="sr-only">Reveal the mobile </span>Search');
        $ddWrapper.hide();
    };

    // Public method
    var init = function() {
        var $ddWrapper = $('.sitesearch-wrapper'),
            $searchTrigger = $('.sitesearch-reveal');

        _setAccessAttrs($ddWrapper, $searchTrigger);

        $searchTrigger.on('click', function(e) {
            e.preventDefault();
            _toggleAttrs($ddWrapper, $searchTrigger);

            // Emit event so other modals will close
            pubsubEvent.emit('pubsubEvent_siteSearchClicked');
        });

        // Bind spacebar to anchor
        $searchTrigger.on('keypress', function(e) {
            if (e.which === 32) {
                $(this).trigger('click');
                e.preventDefault();
            }
        });
    };

    // ----------------------
    // Observe events
    // ----------------------

    pubsubEvent.on('pubsubEvent_mobileNavClicked', _closesearch);

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    BsiteSearch.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary Updates in pge anchor links to scroll to location on page using 'animate'
 *
*/

var BsmoothScroll = (function () {
    'use strict';

    var _bindUIActions = function () {
        $('a[href*="#"]:not([href="#"])').click(function(e) {
            if (
                $(this).is('.navdesktop-js__reveal--is-parent') ||
                $(this).is('.navmobile-trigger')
            ) {
                return;
            }

            /**
            * Do smooth scroll only when we link to an anchor on the same page
            * Note: if using the "Anchor on this page" function in tinymce
            * we cannot compare the location.pathname is there would be none (ie: link is <a href="#anchor-target"></a>)
            */
            var destinationPath = this.pathname.replace(/^\//, '');

            if (destinationPath === '' || (location.pathname.replace(/^\//, '') === destinationPath && location.hostname === this.hostname)) {
                e.preventDefault();
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                scrollToTarget(target);
                return;
            }

            return;
        });
    };

    var init = function () {
        _bindUIActions();
    };

    function scrollToTarget (target) {
        if (target.length) {
            target.attr('tabindex', -1);
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 500, function() {
                target.focus();
            });
            return false;
        }
    }

    return {
        init: init
    };
})();

$(document).ready(function() {
    BsmoothScroll.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary This js determines how the table behaves in situations where there is insufficient horizontal space to display all the columns.
 * There are 3 options for the table display determined by a wrapper class.
 * 1. Row comparisons (.c-table-js--row-comparison) - means that comparing data across rows is most important for the user, and therefore the table should overflow horzontally with the row headers pinned.
 * 2. Column comparisons (.c-table-js--col-comparison) - means that comparing data between columns is most important for the user. In this scenario the table's columns and rows should switch (so the column headers become row headers and vice versa) and the table should overflow horizontally with the row headers pinned.
 * 3. Accordion (Entry data grouped) default - means that the data in each row should be consumed together onscreen at once, comparisons are not so important. In this case column headers and their data are merged into a single cell with show/hide functionality as required.
 *
*/

// Create namespace for module
var Ctable = (function () {
    'use strict';

    // Validation method
    // Check all elements that shouls be are th
    // var _spanValidation = function(tableInnards) {

    // }

    // Validation method
    // if non default table and rowspan/colspan used check not been applied to first header element
    var _spanValidation = function(tableInnards) {
        var $firstRow = tableInnards.table.find('tr').first(),
            $firstHeader = $firstRow.find('>:first-child');

        // Check that the first element is a th
        if ($firstHeader.is('th')) {
            // Check that it doesnt have a colspan/rowspan on that first element
            var checkAttrRowspan = $firstHeader.attr('rowspan');
            if (typeof checkAttrRowspan !== typeof undefined && checkAttrRowspan !== false) {
                return false;
            } else {
                var checkAttrColspan = $firstHeader.attr('colspan');
                if (typeof checkAttrColspan !== typeof undefined && checkAttrColspan !== false) {
                    return false;
                } else {
                    if ($firstHeader.parents('thead').length) {
                        $firstHeader.addClass('c-table-js-header-cell');
                        $firstHeader.siblings().addClass('c-table-js-header-cell');
                        return true;
                    } else if ($firstHeader.parents('tbody').length) {
                        $firstHeader.addClass('c-table-js-header-cell');
                        $firstHeader.parents('tbody').find('tr >:first-child').addClass('c-table-js-header-cell');
                        return true;
                    }
                }
            }
        } else {
            return false;
        }
    };

    // Add classes to table so easily targetted
    var _addBEMClasses = function(tableInnards) {
        var $thead = tableInnards.thead,
            $trows = tableInnards.trows;

        var classRoot = 'c-table-js__';

        $thead.addClass(classRoot + 'thead');
        $trows.addClass(classRoot + 'row');
        $trows.find('td').each(function() {
            $(this).addClass(classRoot + 'cell');
        });
    };

    // Define private methods here. These are not available outside this closure
    var _buildRowTable = function (tableInnards) {
        if (_spanValidation(tableInnards)) {
            // console.log('can build the row table')
            _addBEMClasses(tableInnards);
        } else {
            // console.log('can NOT build the row table!')
            return;
        }
    };

    var _buildColTable = function (tableInnards) {
        if (_spanValidation(tableInnards)) {
            // console.log('can build the col table')
            _addBEMClasses(tableInnards);
        } else {
            // console.log('can NOT build the col table!')
            return;
        }
    };

    var _buildDefaultTable = function ($tableWrap, tableInnards) {
        // Variables
        var $table = tableInnards.table,
            $thead = tableInnards.thead,
            $trows = tableInnards.trows,
            maxrows = $tableWrap.attr('data-max-rows'),
            tableWrapper;

        // Check to see if colspans/rowspans present.
        // This table style does not work with colspans/rowspans.
        if (!tableInnards.table.find('[colspan], [rowspan]').length && $thead.length > 0) {
            // console.log('can build the default table');

            _addBEMClasses(tableInnards);

            // Wrap table
            // $table.wrap('<div class="js-table-wrapper"></div>');
            $table.wrap('<div class="c-table-js-wrapper" style="position: relative"></div>');
            $table.wrap('<div class="overflow-liner"></div>');
            tableWrapper = $table.parent();

            // Tables that exceed available width, add helper arrows
            // tableWrapper.mbieOverflowHelper();

            // Mobile: Click to reveal hidden cells
            $trows.find('.c-table-js__reveal').on('click', function() {
                var row = $(this).parent().parent();
                if (row.hasClass('c-table-js__row--active')) {
                    row.removeClass('c-table-js__row--active');
                } else {
                    row.addClass('c-table-js__row--active');
                }
            });

            // // If rows exceed limit, hide them
            if (maxrows !== undefined && maxrows > 0) {
                if ($trows.length > maxrows) {
                    // Append view more button
                    tableWrapper.append('<div class="c-table-js__view-full-table"><button class="c-table-js__view-full-table-btn"><span class="c-table-js__view-full-table-type">See full table</span></button</div>');
                    // Hide additional rows
                    $trows.each(function(index, el) {
                        if (index > (maxrows - 1)) {
                            $(this).addClass('hidden-md--max');
                        }
                    });
                }

                // // Click event to view all
                tableWrapper.find('.c-table-js__view-full-table button').on('click', function() {
                    $trows.removeClass('hidden-md--max');
                    $(this).parent().hide();
                    return false;
                });
            }
        } else {
            // console.log('can NOT build the default table');
            return;
        }
    };

    var _determineTableType = function($tableWrap) {
        // Variables
        var tableInnards = {
            table: $tableWrap.find('table'),
            thead: $tableWrap.find('thead'),
            theaders: $tableWrap.find('th'),
            trows: $tableWrap.find('tbody tr')
        };

        // Determine which responsive table to display
        if ($tableWrap.hasClass('c-table-js--row-comparison')) {
            _buildRowTable(tableInnards);
        } else if ($tableWrap.hasClass('c-table-js--col-comparison')) {
            _buildColTable(tableInnards);
        } else {
            _buildDefaultTable($tableWrap, tableInnards);
        }
    };

    // Public method
    var init = function() {
        var cmsTables = $('table').not('.c-table-js');

        cmsTables.each(function() {
            $(this).wrap('<div class="c-table-js c-table-js--row-comparison tablewrap--cms"></div>');
        });

        // Apply styles to tables
        $('.c-table-js').each(function() {
            _determineTableType($(this));
            $(this).find('table').mbieOverflowHelper();
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    Ctable.init();
});

/**
 * @author dan.west@chrometoaster.com
 *
 * @summary
*/

var HtriggerFormSubmit = (function () {
    'use strict';

    var showReset = function(reset) {
        if ($('[data-hasfilters]').length < 1) {
            reset.fadeOut(0);
        }
        $('input, select').change(function(e) {
            reset.fadeIn(500);
        });
    };

    // Public method
    var init = function() {
        var reset = $('input[type=reset]');

        showReset(reset);

        $('.h-triggerFormSubmit-js').on('choice', function() {
            $(this).closest('form').find('[type="submit"]').first().click();
        });

        // Clear selects when form reset button is clicked
        reset.on('click', function() {
            var selects = $('select'),
                inputs = $('fieldset input'),
                submit = $(this).closest('form').find('[type="submit"]'); // not actions

            submit.attr('disabled', true);

            if (selects.length > 0) {
                selects.val('').trigger('change');
            }

            if (inputs.length > 0) {
                inputs.val('');
            }

            if ($('[data-hasfilters]').length > 0) {
                $(this).closest('form').submit();
            }

            reset.fadeOut(500);
            submit.attr('disabled', false);
        });
    };

    // Expose objects here
    return {
        init: init
    };
})();

$(document).ready(function() {
    HtriggerFormSubmit.init();
});

